
<div class="rr-reviews-display-images rr-reviews-display-images-container">
  <ul class="rr-reviews-display-images rr-reviews-display-images-img-container">
    <li
      v-for="(e, i) in data"
      :key="i"
      class="rr-reviews-display-images rr-reviews-display-images-img-thumbnail"
    >
      <img
        :src="e"
        :width="config.imageSize"
        :height="config.imageSize"
        loading="lazy"
        @click="openModal(i)"
      />
      <button
        v-if="deleteOption"
        type="button"
        class="btn-close"
        aria-label="remove"
        @click="removeImage(i)"
      >
        x
      </button>
    </li>
  </ul>
</div>
